import React from 'react';
import { Timer } from './Timer';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-black border-t border-white/5 pt-[8px] pb-[8px]" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="mb-10" data-id="element-104">
          <h2 className="text-4xl font-black text-white mb-4" data-id="element-105">
            ÚLTIMA OPORTUNIDAD
          </h2>
        </div>

        <Timer data-id="element-106" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12 mb-12" data-id="element-107">
          <motion.a href="https://www.impulsodigitalstore.com/cart/42971518435405:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-green text-white py-6 px-6 rounded-2xl shadow-[0_8px_30px_rgba(57,185,0,0.3)] flex flex-col items-center justify-center gap-2 border-2 border-brand-green hover:shadow-[0_10px_40px_rgba(57,185,0,0.5)] transition-all" data-id="element-108">
            <span className="text-xl font-bold flex items-center gap-2" data-id="element-109">
              📘 MEGAPACK ANTI INFLAMACIÓN
            </span>
            <div className="flex items-center gap-3" data-id="element-110">
              <span className="line-through text-white/70 text-sm" data-id="element-111">
                $65.000
              </span>
              <span className="font-black text-2xl" data-id="element-112">→ $19.990 ARS</span>
            </div>
            <span className="mt-2 bg-white text-brand-green px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-113">
              QUIERO MI MEGAPACK AHORA
            </span>
          </motion.a>

          <motion.a href="https://www.impulsodigitalstore.com/cart/42971519025229:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-pink text-white py-6 px-6 rounded-2xl shadow-[0_8px_30px_rgba(255,45,122,0.3)] flex flex-col items-center justify-center gap-2 border-4 border-brand-pink hover:shadow-[0_10px_40px_rgba(255,45,122,0.5)] transition-all relative" data-id="element-114">
            <div className="absolute -top-4 bg-white text-brand-pink px-4 py-1 rounded-full text-xs font-black uppercase shadow-md" data-id="element-115">
              MÁS POPULAR
            </div>
            <span className="text-xl font-bold flex items-center gap-2" data-id="element-116">
              🏆 MEGAPACK + EFECTO JEAN FLOJO ⭐
            </span>
            <div className="flex items-center gap-3" data-id="element-117">
              <span className="line-through text-white/70 text-sm" data-id="element-118">
                $85.000
              </span>
              <span className="font-black text-2xl" data-id="element-119">→ $27.990 ARS</span>
            </div>
            <span className="mt-2 bg-white text-brand-pink px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-120">
              QUIERO EL COMBO COMPLETO
            </span>
          </motion.a>
        </div>

        <div className="bg-white/5 backdrop-blur-sm py-6 rounded-2xl border border-white/10" data-id="element-121">
          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-sm font-bold text-gray-300" data-id="element-122">
            <span className="flex items-center gap-2" data-id="element-123">
              <Lock size={18} className="text-brand-green" data-id="element-124" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-125">
              <Zap size={18} className="text-brand-green" data-id="element-126" /> Acceso en 5 minutos
            </span>
            <span className="flex items-center gap-2" data-id="element-127">
              <Shield size={18} className="text-brand-green" data-id="element-128" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-129">
              <CreditCard size={18} className="text-brand-green" data-id="element-130" /> Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}